/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDevise } from '../../models/api-response-devise';

export interface GetDeviseByRef$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
}

export function getDeviseByRef(http: HttpClient, rootUrl: string, params: GetDeviseByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDevise>> {
  const rb = new RequestBuilder(rootUrl, getDeviseByRef.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDevise>;
    })
  );
}

getDeviseByRef.PATH = '/v1/api/ui/devise/{ref}';
